import { FC } from 'react'
import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';


interface IDeloiteListItemHeaderProps {
    title: string;
}

export const DeloitteListItemHeader: FC<IDeloiteListItemHeaderProps> = (props) => {
    const { title, children } = props;
    return (
        <Box marginBottom={2}>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid>
                    <Typography
                        variant="body1"
                        component="span"
                        noWrap
                    >
                        {title}
                    </Typography>
                </Grid>
                <Grid>
                    {children ?? (<Box height={48} />)}
                </Grid>
            </Grid>
        </Box>
    )
}